import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { SetSubscribersEpicReducer } from "./SetSubscribers.epics.js";
const setSubscribersDefaultReducerState = {
  value: getDefaultAsyncWrapperObj()
};
const setSubscribersReducer = (state = setSubscribersDefaultReducerState, action) => {
  state = SetSubscribersEpicReducer.reduxChange(state, action);
  return state;
};
const SetSubscribersReducersMapObject = {
  setSubscribers: setSubscribersReducer
};
export {
  SetSubscribersReducersMapObject,
  SetSubscribersReducersMapObject as default,
  setSubscribersDefaultReducerState,
  setSubscribersReducer
};
//# sourceMappingURL=SetSubscribers.ducks.js.map
